// src/components/ui/ThemeToggle.jsx
import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import useSettingsStore from '../../stores/settingsStore';

/**
 * ThemeToggle component that switches between light and dark mode
 * @param {Object} props - Component props
 * @param {string} [props.size] - Size of the IconButton ('small', 'medium', 'large')
 * @param {string} [props.color] - Color of the icon (inherit, primary, secondary, etc.)
 * @param {Object} [props.sx] - Additional MUI sx styles
 */
const ThemeToggle = ({ size = 'medium', color = 'inherit', sx = {} }) => {
  const theme = useTheme();
  const { settings, updateSetting } = useSettingsStore();
  const isDarkMode = settings.theme === 'dark';

  const handleToggleTheme = () => {
    const newTheme = isDarkMode ? 'light' : 'dark';
    updateSetting('theme', newTheme);
  };

  return (
    <Tooltip title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}>
      <IconButton
        onClick={handleToggleTheme}
        color={color}
        size={size}
        sx={{
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'rotate(12deg)'
          },
          ...sx
        }}
        aria-label="Toggle theme"
      >
        {isDarkMode ? <LightModeIcon fontSize="inherit" /> : <DarkModeIcon fontSize="inherit" />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;